var _path, _path2, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerClubBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 78,
    viewBox: "0 0 282 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H270C276.627 0 282 5.37258 282 12V66C282 72.6274 276.627 78 270 78H12C5.37258 78 0 72.6274 0 66V12Z",
    fill: "url(#paint0_linear_732_28958)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_732_28958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 282,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H270C276.627 0 282 5.37258 282 12V66C282 72.6274 276.627 78 270 78H12C5.37258 78 0 72.6274 0 66V12Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_732_28958)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_732_28958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -91,
    y: -97,
    width: 296,
    height: 296
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 51,
    r: 148,
    fill: "url(#paint1_radial_732_28958)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_732_28958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5339 52.2423L65.4053 53.9852C65.5227 54.2262 65.8379 54.4549 66.1037 54.5043L67.6797 54.7639C68.6871 54.9307 68.9219 55.66 68.1988 56.3893L66.9689 57.6192C66.765 57.8232 66.6476 58.2249 66.7155 58.5154L67.0678 60.0358C67.3459 61.2348 66.7032 61.7045 65.6463 61.0741L64.1692 60.1965C63.9034 60.0358 63.4585 60.0358 63.1927 60.1965L61.7156 61.0741C60.6587 61.6983 60.016 61.2348 60.2941 60.0358L60.6464 58.5154C60.7144 58.2311 60.5969 57.8294 60.393 57.6192L59.1631 56.3893C58.44 55.6662 58.6748 54.9369 59.6822 54.7639L61.2582 54.5043C61.524 54.461 61.8392 54.2262 61.9566 53.9852L62.8281 52.2423C63.2916 51.2967 64.058 51.2967 64.5339 52.2423Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.967 52.1124H56.2588",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1129 60.765H56.2588",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8768 56.4387H56.2588",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5595 45.6069L78.4858 47.233C78.3358 47.4552 78.2954 47.8426 78.3854 48.0974L78.9486 49.5921C79.3078 50.548 78.7937 51.116 77.8005 50.8544L76.1204 50.4042C75.8418 50.3296 75.4352 50.4287 75.2177 50.6329L74.0771 51.6981C73.1778 52.5385 72.4496 52.2167 72.4672 50.9862L72.4886 49.2682C72.4949 48.9577 72.2724 48.5723 72.0004 48.4225L70.5018 47.5821C69.4328 46.979 69.5128 46.1906 70.6902 45.8319L72.1831 45.3768C72.4633 45.2935 72.7525 44.991 72.8325 44.7093L73.2827 43.0292C73.5473 42.0414 74.2963 41.8802 74.9499 42.6661L75.9627 43.9012C76.1331 44.1097 76.494 44.2652 76.7615 44.2464L78.7066 44.1297C79.7573 44.0583 80.1405 44.722 79.5595 45.6069Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3854 41.5867L75.5312 38.3752",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9661 44.3071L68.0391 42.7014",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0932 41.0738L71.7842 40.5386",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7795 38.4627L53.4435 36.6307C53.5375 36.3796 53.4863 35.9936 53.3392 35.7668L52.4424 34.4451C51.8698 33.5996 52.237 32.9271 53.2638 32.9495L55.0026 32.9947C55.2909 33.0022 55.6631 32.8107 55.827 32.5615L56.6871 31.2592C57.3652 30.232 58.1483 30.3748 58.4188 31.5753L58.7993 33.2508C58.8657 33.5542 59.1721 33.8769 59.4716 33.959L61.1251 34.426C62.3054 34.7627 62.4118 35.548 61.3507 36.1718L60.0055 36.9631C59.7525 37.1095 59.542 37.4713 59.53 37.7639L59.4848 39.5026C59.4582 40.5249 58.7676 40.8567 57.9485 40.2452L56.6752 39.2809C56.4609 39.118 56.0735 39.0511 55.8179 39.1319L53.9539 39.6998C52.949 40.0147 52.4213 39.4588 52.7795 38.4627Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8297 41.8644L58.3828 44.5538",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3807 37.252L64.6572 38.5967",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.095 41.127L61.5205 41.5752",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1667 44.0551L45.8402 45.0532C46.0691 45.1929 46.4578 45.2156 46.7083 45.114L48.1756 44.4829C49.114 44.0804 49.705 44.568 49.4892 45.572L49.1164 47.271C49.0545 47.5527 49.1722 47.9543 49.3861 48.1623L50.5025 49.2529C51.3831 50.1128 51.095 50.855 49.865 50.8938L48.1478 50.951C47.8373 50.9589 47.4626 51.1988 47.3254 51.4774L46.5544 53.0129C46.0008 54.1084 45.2096 54.0646 44.7974 52.9048L44.2745 51.4343C44.1785 51.1583 43.863 50.8832 43.5779 50.8162L41.879 50.4434C40.8801 50.2242 40.6848 49.4834 41.4399 48.7945L42.6273 47.7262C42.8278 47.5465 42.9667 47.1788 42.9357 46.9125L42.73 44.9748C42.6106 43.9285 43.2561 43.5153 44.1667 44.0551Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2511 46.4082L37.1279 48.4073",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3536 54.6952L41.792 55.6948",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9805 51.7179L39.46 52.0511",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4274 39.3869L30.2988 41.1298C30.4163 41.3708 30.7315 41.5995 30.9972 41.649L32.5732 41.9085C33.5806 42.0754 33.8155 42.8047 33.0924 43.534L31.8625 44.7639C31.6585 44.9678 31.5411 45.3696 31.6091 45.66L31.9614 47.1804C32.2395 48.3794 31.5967 48.8491 30.5399 48.2187L29.0628 47.3411C28.797 47.1804 28.352 47.1804 28.0863 47.3411L26.6091 48.2187C25.5523 48.8429 24.9095 48.3794 25.1877 47.1804L25.5399 45.66C25.6079 45.3757 25.4905 44.974 25.2865 44.7639L24.0566 43.534C23.3335 42.8109 23.5684 42.0816 24.5758 41.9085L26.1518 41.649C26.4176 41.6057 26.7328 41.3708 26.8502 41.1298L27.7216 39.3869C28.1852 38.4413 28.9515 38.4413 29.4274 39.3869Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8616 39.2572H21.1533",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0074 47.9097H21.1533",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7714 43.5834H21.1533",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4511 32.7522L43.3774 34.3783C43.2274 34.6005 43.187 34.9878 43.277 35.2427L43.8402 36.7373C44.1994 37.6932 43.6853 38.2613 42.6921 37.9997L41.012 37.5495C40.7334 37.4748 40.3268 37.574 40.1093 37.7781L38.9687 38.8434C38.0694 39.6837 37.3412 39.362 37.3588 38.1315L37.3802 36.4135C37.3865 36.103 37.164 35.7176 36.892 35.5678L35.3934 34.7274C34.3244 34.1242 34.4044 33.3358 35.5818 32.9772L37.0747 32.5221C37.3549 32.4388 37.6441 32.1362 37.7241 31.8546L38.1743 30.1745C38.4389 29.1867 39.1879 29.0254 39.8415 29.8114L40.8543 31.0464C41.0247 31.2549 41.3856 31.4105 41.6531 31.3917L43.5982 31.2749C44.6489 31.2035 45.0321 31.8673 44.4511 32.7522Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2809 28.7318L40.4268 25.5204",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8597 31.4523L32.9326 29.8466",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9887 28.2187L36.6797 27.6835",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.673 25.6071L18.3371 23.7751C18.431 23.524 18.3799 23.138 18.2327 22.9112L17.3359 21.5895C16.7634 20.744 17.1306 20.0715 18.1574 20.0939L19.8961 20.1391C20.1845 20.1466 20.5566 19.9552 20.7205 19.7059L21.5806 18.4036C22.2587 17.3764 23.0419 17.5192 23.3123 18.7197L23.6928 20.3952C23.7593 20.6986 24.0656 21.0213 24.3651 21.1034L26.0186 21.5704C27.1989 21.9071 27.3053 22.6924 26.2443 23.3162L24.8991 24.1075C24.6461 24.2539 24.4356 24.6157 24.4236 24.9083L24.3784 26.647C24.3518 27.6693 23.6612 28.0011 22.8421 27.3896L21.5688 26.4253C21.3544 26.2624 20.9671 26.1955 20.7114 26.2763L18.8474 26.8442C17.8425 27.1591 17.3149 26.6033 17.673 25.6071Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7243 29.0091L23.2773 31.6985",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2752 24.3965L29.5518 25.7412",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9915 28.2717L26.417 28.72",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06218 31.1995L10.7357 32.1976C10.9646 32.3373 11.3533 32.36 11.6038 32.2584L13.0711 31.6273C14.0095 31.2248 14.6005 31.7124 14.3847 32.7165L14.0119 34.4154C13.9501 34.6971 14.0677 35.0988 14.2816 35.3068L15.398 36.3973C16.2786 37.2572 15.9905 37.9994 14.7605 38.0382L13.0433 38.0954C12.7328 38.1033 12.3581 38.3432 12.2209 38.6218L11.4499 40.1573C10.8964 41.2528 10.1051 41.209 9.69295 40.0492L9.16998 38.5788C9.07397 38.3027 8.75849 38.0276 8.47343 37.9606L6.77451 37.5878C5.77565 37.3686 5.58027 36.6278 6.33544 35.9389L7.52285 34.8706C7.72335 34.6909 7.86221 34.3232 7.83117 34.0569L7.6255 32.1192C7.50611 31.0729 8.15157 30.6597 9.06218 31.1995Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1437 33.5529L2.02051 35.5521",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24616 41.8398L6.68457 42.8394",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87307 38.8625L4.35254 39.1957",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.372157 45.772L-1.44581 47.3981C-1.59584 47.6203 -1.63628 48.0076 -1.54622 48.2625L-0.983012 49.7571C-0.623823 50.713 -1.13798 51.281 -2.13112 51.0194L-3.8112 50.5693C-4.0898 50.4946 -4.49641 50.5938 -4.71398 50.7979L-5.85454 51.8632C-6.75384 52.7035 -7.482 52.3817 -7.46448 51.1513L-7.443 49.4332C-7.43672 49.1227 -7.65921 48.7374 -7.93125 48.5876L-9.42985 47.7472C-10.4989 47.144 -10.4188 46.3556 -9.2414 45.997L-7.74856 45.5419C-7.46836 45.4586 -7.17917 45.156 -7.09917 44.8743L-6.64899 43.1943C-6.38431 42.2065 -5.6353 42.0452 -4.98173 42.8311L-3.96894 44.0662C-3.79859 44.2747 -3.4376 44.4303 -3.17014 44.4114L-1.22505 44.2947C-0.174375 44.2233 0.208813 44.887 -0.372157 45.772Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.883 39.3871L108.755 41.1299C108.872 41.371 109.188 41.5996 109.453 41.6491L111.029 41.9087C112.037 42.0755 112.272 42.8048 111.548 43.5341L110.319 44.764C110.115 44.968 109.997 45.3697 110.065 45.6602L110.417 47.1805C110.696 48.3795 110.053 48.8492 108.996 48.2188L107.519 47.3412C107.253 47.1805 106.808 47.1805 106.542 47.3412L105.065 48.2188C104.008 48.8431 103.366 48.3795 103.644 47.1805L103.996 45.6602C104.064 45.3759 103.947 44.9741 103.743 44.764L102.513 43.5341C101.79 42.811 102.024 42.0817 103.032 41.9087L104.608 41.6491C104.874 41.6058 105.189 41.371 105.306 41.1299L106.178 39.3871C106.641 38.4415 107.408 38.4415 107.883 39.3871Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.316 39.2573H99.6074",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.462 47.9098H99.6074",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.225 43.5835H99.6074",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.908 32.7523L121.834 34.3784C121.684 34.6006 121.644 34.9879 121.734 35.2428L122.297 36.7375C122.656 37.6933 122.142 38.2614 121.149 37.9998L119.469 37.5496C119.19 37.475 118.784 37.5741 118.566 37.7782L117.426 38.8435C116.526 39.6839 115.798 39.3621 115.816 38.1316L115.837 36.4136C115.844 36.1031 115.621 35.7177 115.349 35.5679L113.85 34.7275C112.781 34.1244 112.861 33.3359 114.039 32.9773L115.532 32.5222C115.812 32.4389 116.101 32.1364 116.181 31.8547L116.631 30.1746C116.896 29.1868 117.645 29.0256 118.299 29.8115L119.311 31.0465C119.482 31.2551 119.843 31.4106 120.11 31.3918L122.055 31.275C123.106 31.2037 123.489 31.8674 122.908 32.7523Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.734 28.7319L118.88 25.5205",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.315 31.4525L111.388 29.8468",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.444 28.2188L115.135 27.6836",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1261 25.6077L96.7902 23.7757C96.8842 23.5246 96.833 23.1386 96.6859 22.9118L95.7891 21.5901C95.2165 20.7446 95.5837 20.0722 96.6105 20.0945L98.3492 20.1397C98.6376 20.1472 99.0098 19.9558 99.1736 19.7065L100.034 18.4042C100.712 17.377 101.495 17.5198 101.765 18.7203L102.146 20.3958C102.212 20.6992 102.519 21.0219 102.818 21.104L104.472 21.5711C105.652 21.9078 105.758 22.693 104.697 23.3168L103.352 24.1081C103.099 24.2545 102.889 24.6163 102.877 24.9089L102.831 26.6476C102.805 27.6699 102.114 28.0017 101.295 27.3902L100.022 26.426C99.8076 26.263 99.4202 26.1961 99.1646 26.2769L97.3006 26.8448C96.2956 27.1597 95.768 26.6039 96.1261 25.6077Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1784 29.0093L101.731 31.6987",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.729 24.3966L108.006 25.7413",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.444 28.2719L104.869 28.7201",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5173 31.2006L89.1908 32.1987C89.4197 32.3384 89.8084 32.3611 90.0589 32.2595L91.5262 31.6284C92.4646 31.2259 93.0556 31.7135 92.8398 32.7175L92.467 34.4165C92.4051 34.6982 92.5228 35.0999 92.7367 35.3079L93.853 36.3984C94.7337 37.2583 94.4456 38.0005 93.2156 38.0393L91.4984 38.0965C91.1879 38.1044 90.8131 38.3443 90.6759 38.6229L89.905 40.1584C89.3514 41.2539 88.5602 41.2101 88.148 40.0503L87.6251 38.5799C87.529 38.3038 87.2136 38.0287 86.9285 37.9617L85.2296 37.5889C84.2307 37.3697 84.0354 36.6289 84.7905 35.94L85.9779 34.8717C86.1784 34.692 86.3173 34.3243 86.2862 34.058L86.0806 32.1203C85.9612 31.074 86.6067 30.6608 87.5173 31.2006Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5998 33.5535L80.4766 35.5527",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7022 41.8405L85.1406 42.8401",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3311 38.8633L82.8105 39.1965",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.5 21.2573L142.371 23.0002C142.489 23.2412 142.804 23.4699 143.069 23.5193L144.646 23.7789C145.653 23.9458 145.888 24.6751 145.165 25.4043L143.935 26.6342C143.731 26.8382 143.613 27.2399 143.681 27.5304L144.034 29.0508C144.312 30.2498 143.669 30.7195 142.612 30.0891L141.135 29.2115C140.869 29.0508 140.424 29.0508 140.159 29.2115L138.681 30.0891C137.625 30.7133 136.982 30.2498 137.26 29.0508L137.612 27.5304C137.68 27.2461 137.563 26.8444 137.359 26.6342L136.129 25.4043C135.406 24.6812 135.641 23.9519 136.648 23.7789L138.224 23.5193C138.49 23.4761 138.805 23.2412 138.922 23.0002L139.794 21.2573C140.257 20.3117 141.024 20.3117 141.5 21.2573Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.934 21.1278H133.226",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.08 29.7802H133.226",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.844 25.4539H133.226",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.526 14.6222L155.453 16.2483C155.303 16.4705 155.262 16.8578 155.352 17.1127L155.915 18.6073C156.275 19.5632 155.76 20.1312 154.767 19.8697L153.087 19.4195C152.809 19.3448 152.402 19.444 152.184 19.6481L151.044 20.7134C150.145 21.5537 149.416 21.232 149.434 20.0015L149.455 18.2835C149.462 17.973 149.239 17.5876 148.967 17.4378L147.469 16.5974C146.4 15.9942 146.48 15.2058 147.657 14.8472L149.15 14.3921C149.43 14.3088 149.719 14.0062 149.799 13.7245L150.249 12.0445C150.514 11.0567 151.263 10.8954 151.917 11.6814L152.93 12.9164C153.1 13.1249 153.461 13.2805 153.728 13.2617L155.673 13.1449C156.724 13.0735 157.107 13.7372 156.526 14.6222Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.355 10.6019L152.501 7.3905",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.935 13.3225L145.008 11.7168",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.064 10.0889L148.755 9.55371",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.747 7.47805L130.411 5.64611C130.505 5.395 130.454 5.00896 130.307 4.78218L129.41 3.46046C128.838 2.61496 129.205 1.94252 130.232 1.96485L131.97 2.01006C132.259 2.01756 132.631 1.82613 132.795 1.57683L133.655 0.274583C134.333 -0.752618 135.116 -0.609849 135.387 0.590651L135.767 2.26616C135.833 2.56953 136.14 2.89225 136.439 2.97436L138.093 3.44141C139.273 3.77812 139.38 4.56341 138.318 5.1872L136.973 5.97847C136.72 6.1249 136.51 6.48665 136.498 6.77924L136.453 8.51799C136.426 9.54027 135.735 9.87206 134.916 9.26058L133.643 8.29631C133.429 8.13336 133.041 8.06645 132.786 8.14724L130.922 8.71517C129.917 9.03004 129.389 8.47422 129.747 7.47805Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.799 10.8798L135.353 13.5692",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35 6.26724L141.627 7.61194",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.064 10.1423L138.489 10.5906",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.136 13.07L122.81 14.0681C123.039 14.2078 123.428 14.2305 123.678 14.1289L125.145 13.4978C126.084 13.0953 126.675 13.5829 126.459 14.5869L126.086 16.2859C126.024 16.5676 126.142 16.9692 126.356 17.1772L127.472 18.2678C128.353 19.1277 128.065 19.8698 126.835 19.9087L125.118 19.9659C124.807 19.9738 124.432 20.2137 124.295 20.4923L123.524 22.0278C122.971 23.1233 122.179 23.0794 121.767 21.9197L121.244 20.4492C121.148 20.1731 120.833 19.8981 120.548 19.8311L118.849 19.4583C117.85 19.2391 117.654 18.4983 118.41 17.8094L119.597 16.7411C119.798 16.5614 119.936 16.1937 119.905 15.9274L119.7 13.9897C119.58 12.9434 120.226 12.5302 121.136 13.07Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.219 15.4232L114.096 17.4224",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.322 23.7101L118.761 24.7097",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.95 20.7327L116.43 21.0659",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1647 71.5249L98.0361 73.2677C98.1536 73.5088 98.4688 73.7375 98.7345 73.7869L100.311 74.0465C101.318 74.2133 101.553 74.9426 100.83 75.6719L99.5998 76.9018C99.3958 77.1058 99.2784 77.5075 99.3464 77.798L99.6987 79.3184C99.9768 80.5174 99.334 80.9871 98.2772 80.3567L96.8001 79.479C96.5343 79.3184 96.0893 79.3184 95.8236 79.479L94.3464 80.3567C93.2896 80.9809 92.6468 80.5174 92.925 79.3184L93.2772 77.798C93.3452 77.5137 93.2278 77.112 93.0238 76.9018L91.794 75.6719C91.0708 74.9488 91.3057 74.2195 92.3131 74.0465L93.8891 73.7869C94.1549 73.7436 94.4701 73.5088 94.5875 73.2677L95.4589 71.5249C95.9225 70.5793 96.6888 70.5793 97.1647 71.5249Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5998 71.395H88.8916",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5096 75.7214H88.8916",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.193 64.8895L111.12 66.5156C110.97 66.7378 110.929 67.1251 111.019 67.38L111.582 68.8747C111.942 69.8305 111.427 70.3986 110.434 70.137L108.754 69.6868C108.476 69.6122 108.069 69.7113 107.851 69.9155L106.711 70.9807C105.812 71.8211 105.083 71.4993 105.101 70.2688L105.122 68.5508C105.129 68.2403 104.906 67.8549 104.634 67.7051L103.136 66.8647C102.067 66.2616 102.147 65.4732 103.324 65.1145L104.817 64.6594C105.097 64.5761 105.386 64.2736 105.466 63.9919L105.916 62.3118C106.181 61.324 106.93 61.1628 107.584 61.9487L108.596 63.1838C108.767 63.3923 109.128 63.5478 109.395 63.529L111.34 63.4123C112.391 63.3409 112.774 64.0046 112.193 64.8895Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.023 60.8694L108.169 57.658",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.604 63.5897L100.677 61.984",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.733 60.3563L104.424 59.821",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4152 57.7458L86.0793 55.9138C86.1732 55.6627 86.122 55.2767 85.9749 55.0499L85.0781 53.7282C84.5056 52.8827 84.8728 52.2102 85.8995 52.2325L87.6383 52.2778C87.9266 52.2853 88.2988 52.0938 88.4627 51.8445L89.3228 50.5423C90.0009 49.5151 90.7841 49.6579 91.0545 50.8584L91.435 52.5339C91.5014 52.8372 91.8078 53.16 92.1073 53.2421L93.7608 53.7091C94.9411 54.0458 95.0475 54.8311 93.9864 55.4549L92.6412 56.2462C92.3883 56.3926 92.1778 56.7543 92.1658 57.0469L92.1206 58.7857C92.094 59.808 91.4034 60.1398 90.5843 59.5283L89.311 58.564C89.0966 58.4011 88.7093 58.3342 88.4536 58.4149L86.5896 58.9829C85.5847 59.2977 85.0571 58.7419 85.4152 57.7458Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4645 61.1474L91.0176 63.8368",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0155 56.5347L97.292 57.8794",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7288 60.4099L94.1543 60.8582",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8034 63.338L78.4769 64.3361C78.7058 64.4758 79.0945 64.4984 79.345 64.3968L80.8123 63.7658C81.7508 63.3632 82.3417 63.8508 82.1259 64.8549L81.7531 66.5538C81.6913 66.8355 81.809 67.2372 82.0228 67.4452L83.1392 68.5358C84.0198 69.3957 83.7317 70.1378 82.5017 70.1766L80.7845 70.2338C80.4741 70.2417 80.0993 70.4816 79.9621 70.7603L79.1911 72.2958C78.6376 73.3913 77.8463 73.3474 77.4342 72.1876L76.9112 70.7172C76.8152 70.4411 76.4997 70.1661 76.2146 70.099L74.5157 69.7262C73.5169 69.507 73.3215 68.7662 74.0767 68.0773L75.2641 67.0091C75.4646 66.8294 75.6034 66.4616 75.5724 66.1953L75.3667 64.2576C75.2473 63.2113 75.8928 62.7981 76.8034 63.338Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8869 65.6911L69.7637 67.6903",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9893 73.9781L74.4277 74.9777",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6162 71.0007L72.0957 71.3339",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.142 78.4044L145.068 80.0305C144.918 80.2527 144.877 80.64 144.967 80.8949L145.531 82.3896C145.89 83.3454 145.376 83.9135 144.383 83.6519L142.702 83.2017C142.424 83.1271 142.017 83.2262 141.8 83.4303L140.659 84.4956C139.76 85.336 139.032 85.0142 139.049 83.7837L139.071 82.0657C139.077 81.7552 138.854 81.3698 138.582 81.22L137.084 80.3796C136.015 79.7765 136.095 78.988 137.272 78.6294L138.765 78.1743C139.045 78.091 139.334 77.7885 139.415 77.5068L139.865 75.8267C140.129 74.8389 140.878 74.6777 141.532 75.4636L142.545 76.6986C142.715 76.9072 143.076 77.0627 143.344 77.0439L145.289 76.9271C146.339 76.8558 146.722 77.5195 146.142 78.4044Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.971 74.3842L142.117 71.1727",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.551 77.1046L134.624 75.4989",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.679 73.8708L138.37 73.3356",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.363 71.2597L120.027 69.4277C120.121 69.1766 120.07 68.7906 119.923 68.5638L119.026 67.2421C118.454 66.3966 118.821 65.7241 119.848 65.7465L121.587 65.7917C121.875 65.7992 122.247 65.6077 122.411 65.3584L123.271 64.0562C123.949 63.029 124.732 63.1718 125.003 64.3723L125.383 66.0478C125.45 66.3511 125.756 66.6739 126.056 66.756L127.709 67.223C128.889 67.5597 128.996 68.345 127.935 68.9688L126.589 69.7601C126.336 69.9065 126.126 70.2683 126.114 70.5609L126.069 72.2996C126.042 73.3219 125.352 73.6537 124.533 73.0422L123.259 72.0779C123.045 71.915 122.658 71.8481 122.402 71.9289L120.538 72.4968C119.533 72.8117 119.005 72.2558 119.363 71.2597Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.415 74.6613L124.968 77.3507",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.966 70.0489L131.242 71.3936",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.681 73.9241L128.106 74.3723",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.751 76.852L112.424 77.8501C112.653 77.9898 113.042 78.0125 113.292 77.9108L114.76 77.2798C115.698 76.8772 116.289 77.3648 116.073 78.3689L115.7 80.0678C115.639 80.3496 115.756 80.7512 115.97 80.9592L117.086 82.0498C117.967 82.9097 117.679 83.6518 116.449 83.6907L114.732 83.7478C114.421 83.7558 114.047 83.9957 113.909 84.2743L113.138 85.8098C112.585 86.9053 111.794 86.8614 111.381 85.7017L110.858 84.2312C110.762 83.9551 110.447 83.6801 110.162 83.6131L108.463 83.2403C107.464 83.0211 107.269 82.2802 108.024 81.5914L109.211 80.5231C109.412 80.3434 109.551 79.9757 109.52 79.7093L109.314 77.7716C109.195 76.7253 109.84 76.3122 110.751 76.852Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3625 86.2576L76.0265 84.4257C76.1205 84.1745 76.0693 83.7885 75.9222 83.5617L75.0254 82.24C74.4528 81.3945 74.82 80.7221 75.8468 80.7444L77.5856 80.7896C77.8739 80.7971 78.2461 80.6057 78.41 80.3564L79.2701 79.0541C79.9482 78.0269 80.7314 78.1697 81.0018 79.3702L81.3823 81.0457C81.4487 81.3491 81.7551 81.6718 82.0546 81.7539L83.7081 82.221C84.8884 82.5577 84.9948 83.3429 83.9337 83.9667L82.5885 84.758C82.3355 84.9044 82.125 85.2662 82.113 85.5588L82.0678 87.2975C82.0412 88.3198 81.3506 88.6516 80.5315 88.0401L79.2582 87.0759C79.0439 86.9129 78.6565 86.846 78.4009 86.9268L76.5369 87.4947C75.532 87.8096 75.0043 87.2538 75.3625 86.2576Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.709 58.0107L138.58 59.7536C138.698 59.9946 139.013 60.2233 139.278 60.2727L140.854 60.5323C141.862 60.6992 142.097 61.4285 141.374 62.1578L140.144 63.3877C139.94 63.5916 139.822 63.9933 139.89 64.2838L140.243 65.8042C140.521 67.0032 139.878 67.4729 138.821 66.8425L137.344 65.9649C137.078 65.8042 136.633 65.8042 136.368 65.9649L134.89 66.8425C133.834 67.4667 133.191 67.0032 133.469 65.8042L133.821 64.2838C133.889 63.9995 133.772 63.5978 133.568 63.3877L132.338 62.1578C131.615 61.4347 131.85 60.7054 132.857 60.5323L134.433 60.2727C134.699 60.2295 135.014 59.9946 135.131 59.7536L136.003 58.0107C136.466 57.0651 137.233 57.0651 137.709 58.0107Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.141 57.8809H129.433",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.287 66.5333H129.433",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.051 62.2073H129.433",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.735 51.3757L151.662 53.0018C151.512 53.224 151.471 53.6113 151.561 53.8662L152.124 55.3609C152.484 56.3168 151.969 56.8848 150.976 56.6232L149.296 56.173C149.018 56.0984 148.611 56.1975 148.393 56.4017L147.253 57.4669C146.354 58.3073 145.625 57.9855 145.643 56.755L145.664 55.037C145.671 54.7265 145.448 54.3411 145.176 54.1913L143.678 53.3509C142.609 52.7478 142.689 51.9594 143.866 51.6007L145.359 51.1456C145.639 51.0623 145.928 50.7598 146.008 50.4781L146.458 48.798C146.723 47.8102 147.472 47.649 148.126 48.4349L149.138 49.67C149.309 49.8785 149.67 50.034 149.937 50.0152L151.882 49.8985C152.933 49.8271 153.316 50.4908 152.735 51.3757Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.562 47.3554L148.708 44.1439",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.144 50.0759L141.217 48.4702",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.272 46.8421L144.963 46.3069",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.955 44.2313L126.619 42.3994C126.713 42.1483 126.662 41.7623 126.515 41.5355L125.618 40.2138C125.046 39.3683 125.413 38.6958 126.44 38.7181L128.178 38.7634C128.467 38.7709 128.839 38.5794 129.003 38.3301L129.863 37.0279C130.541 36.0007 131.324 36.1434 131.595 37.3439L131.975 39.0195C132.041 39.3228 132.348 39.6455 132.647 39.7277L134.301 40.1947C135.481 40.5314 135.588 41.3167 134.526 41.9405L133.181 42.7318C132.928 42.8782 132.718 43.2399 132.706 43.5325L132.661 45.2713C132.634 46.2936 131.943 46.6254 131.124 46.0139L129.851 45.0496C129.637 44.8867 129.249 44.8197 128.994 44.9005L127.13 45.4685C126.125 45.7833 125.597 45.2275 125.955 44.2313Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.005 47.6329L131.558 50.3223",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.556 43.0203L137.833 44.365",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.272 46.8956L134.697 47.3439",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.34 49.8239L119.013 50.822C119.242 50.9617 119.631 50.9844 119.881 50.8828L121.348 50.2517C122.287 49.8492 122.878 50.3368 122.662 51.3408L122.289 53.0398C122.227 53.3215 122.345 53.7231 122.559 53.9311L123.675 55.0217C124.556 55.8816 124.268 56.6238 123.038 56.6626L121.321 56.7198C121.01 56.7277 120.635 56.9676 120.498 57.2462L119.727 58.7817C119.174 59.8772 118.382 59.8334 117.97 58.6736L117.447 57.2031C117.351 56.927 117.036 56.652 116.751 56.585L115.052 56.2122C114.053 55.993 113.858 55.2522 114.613 54.5633L115.8 53.495C116.001 53.3153 116.14 52.9476 116.109 52.6813L115.903 50.7436C115.783 49.6973 116.429 49.2841 117.34 49.8239Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.423 52.1768L110.3 54.176",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.525 60.4642L114.964 61.4637",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.152 57.4867L112.632 57.8199",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1786 74.614L68.105 76.2401C67.9549 76.4623 67.9145 76.8496 68.0046 77.1045L68.5678 78.5992C68.927 79.555 68.4128 80.1231 67.4197 79.8615L65.7396 79.4113C65.461 79.3366 65.0544 79.4358 64.8368 79.6399L63.6962 80.7052C62.7969 81.5456 62.0688 81.2238 62.0863 79.9933L62.1078 78.2753C62.1141 77.9648 61.8916 77.5794 61.6195 77.4296L60.1209 76.5892C59.0519 75.986 59.132 75.1976 60.3094 74.839L61.8022 74.3839C62.0824 74.3006 62.3716 73.9981 62.4516 73.7164L62.9018 72.0363C63.1665 71.0485 63.9155 70.8873 64.569 71.6732L65.5818 72.9082C65.7522 73.1168 66.1132 73.2723 66.3806 73.2535L68.3257 73.1367C69.3764 73.0654 69.7596 73.7291 69.1786 74.614Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0065 70.5938L65.1523 67.3823",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5872 73.3145L57.6602 71.7087",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7162 70.0806L61.4072 69.5454",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4015 67.4697L43.0656 65.6378C43.1595 65.3867 43.1084 65.0007 42.9613 64.7739L42.0645 63.4522C41.4919 62.6067 41.8591 61.9342 42.8859 61.9565L44.6246 62.0018C44.913 62.0093 45.2852 61.8178 45.449 61.5685L46.3091 60.2663C46.9872 59.2391 47.7704 59.3818 48.0408 60.5824L48.4213 62.2579C48.4878 62.5612 48.7941 62.884 49.0936 62.9661L50.7471 63.4331C51.9275 63.7698 52.0338 64.5551 50.9728 65.1789L49.6276 65.9702C49.3746 66.1166 49.1641 66.4783 49.1521 66.7709L49.1069 68.5097C49.0803 69.532 48.3897 69.8638 47.5706 69.2523L46.2973 68.288C46.0829 68.1251 45.6956 68.0582 45.4399 68.1389L43.576 68.7069C42.571 69.0217 42.0434 68.4659 42.4015 67.4697Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4518 70.8714L48.0049 73.5608",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0028 66.2587L54.2793 67.6034",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7161 70.1338L51.1416 70.582",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7858 73.062L35.4594 74.0601C35.6882 74.1998 36.077 74.2224 36.3274 74.1208L37.7948 73.4898C38.7332 73.0872 39.3242 73.5748 39.1083 74.5789L38.7355 76.2778C38.6737 76.5595 38.7914 76.9612 39.0052 77.1692L40.1216 78.2598C41.0022 79.1197 40.7141 79.8618 39.4842 79.9006L37.7669 79.9578C37.4565 79.9657 37.0817 80.2056 36.9445 80.4843L36.1736 82.0198C35.62 83.1153 34.8287 83.0714 34.4166 81.9116L33.8936 80.4412C33.7976 80.1651 33.4821 79.8901 33.1971 79.823L31.4981 79.4502C30.4993 79.231 30.3039 78.4902 31.0591 77.8013L32.2465 76.7331C32.447 76.5534 32.5858 76.1856 32.5548 75.9193L32.3491 73.9816C32.2297 72.9353 32.8752 72.5221 33.7858 73.062Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8722 75.415L26.749 77.4142",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.05 87.4112L14.714 85.5792C14.808 85.3281 14.7568 84.9421 14.6097 84.7153L13.7129 83.3936C13.1403 82.5481 13.5075 81.8756 14.5343 81.898L16.2731 81.9432C16.5614 81.9507 16.9336 81.7592 17.0975 81.5099L17.9576 80.2077C18.6357 79.1805 19.4189 79.3233 19.6893 80.5238L20.0698 82.1993C20.1362 82.5026 20.4426 82.8254 20.7421 82.9075L22.3956 83.3745C23.5759 83.7112 23.6823 84.4965 22.6212 85.1203L21.276 85.9116C21.023 86.058 20.8125 86.4198 20.8005 86.7123L20.7553 88.4511C20.7287 89.4734 20.0381 89.8052 19.219 89.1937L17.9457 88.2294C17.7314 88.0665 17.344 87.9996 17.0884 88.0803L15.2244 88.6483C14.2195 88.9631 13.6918 88.4073 14.05 87.4112Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8981 67.7341L18.7695 69.477C18.887 69.718 19.2022 69.9467 19.4679 69.9961L21.0439 70.2557C22.0513 70.4226 22.2862 71.1519 21.5631 71.8811L20.3332 73.1111C20.1292 73.315 20.0118 73.7167 20.0798 74.0072L20.4321 75.5276C20.7102 76.7266 20.0674 77.1963 19.0106 76.5659L17.5335 75.6883C17.2677 75.5276 16.8227 75.5276 16.557 75.6883L15.0798 76.5659C14.023 77.1901 13.3802 76.7266 13.6584 75.5276L14.0106 74.0072C14.0786 73.7229 13.9612 73.3212 13.7572 73.1111L12.5274 71.8811C11.8042 71.158 12.0391 70.4288 13.0465 70.2557L14.6225 69.9961C14.8883 69.9529 15.2035 69.718 15.3209 69.477L16.1923 67.7341C16.6559 66.7885 17.4222 66.7885 17.8981 67.7341Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3303 67.6044H9.62207",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4762 76.257H9.62207",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2401 71.9307H9.62207",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9218 61.099L31.8481 62.7251C31.6981 62.9473 31.6577 63.3346 31.7477 63.5895L32.3109 65.0841C32.6701 66.04 32.156 66.6081 31.1628 66.3465L29.4827 65.8963C29.2041 65.8216 28.7975 65.9208 28.58 66.1249L27.4394 67.1902C26.5401 68.0306 25.8119 67.7088 25.8295 66.4783L25.8509 64.7603C25.8572 64.4498 25.6347 64.0644 25.3627 63.9146L23.8641 63.0742C22.7951 62.471 22.8751 61.6826 24.0525 61.324L25.5454 60.8689C25.8256 60.7856 26.1148 60.4831 26.1948 60.2014L26.645 58.5213C26.9096 57.5335 27.6586 57.3722 28.3122 58.1582L29.325 59.3932C29.4954 59.6017 29.8563 59.7573 30.1238 59.7385L32.0689 59.6217C33.1196 59.5504 33.5028 60.2141 32.9218 61.099Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7487 57.0787L28.8945 53.8673",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3294 59.7993L21.4023 58.1936",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4575 56.5655L25.1484 56.0303",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14177 53.9545L6.80582 52.1226C6.89978 51.8714 6.84861 51.4854 6.7015 51.2586L5.80469 49.9369C5.23212 49.0914 5.59935 48.419 6.62611 48.4413L8.36487 48.4865C8.65321 48.494 9.0254 48.3026 9.18926 48.0533L10.0494 46.751C10.7275 45.7238 11.5106 45.8666 11.7811 47.0671L12.1616 48.7426C12.228 49.046 12.5344 49.3687 12.8339 49.4508L14.4874 49.9179C15.6677 50.2546 15.7741 51.0398 14.713 51.6636L13.3678 52.4549C13.1148 52.6013 12.9043 52.9631 12.8923 53.2557L12.8471 54.9944C12.8205 56.0167 12.1299 56.3485 11.3108 55.737L10.0375 54.7728C9.82318 54.6098 9.43584 54.5429 9.18018 54.6237L7.31619 55.1916C6.31126 55.5065 5.78362 54.9507 6.14177 53.9545Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19399 57.3566L11.7471 60.046",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7459 52.744L18.0225 54.0887",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4593 56.619L14.8848 57.0673",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.47005 59.5471L-0.796501 60.5452C-0.567653 60.6849 -0.178898 60.7075 0.0715865 60.6059L1.53889 59.9749C2.47732 59.5723 3.0683 60.0599 2.85245 61.064L2.47965 62.7629C2.41783 63.0446 2.53552 63.4463 2.74938 63.6543L3.86574 64.7449C4.74638 65.6048 4.45826 66.3469 3.22829 66.3857L1.51107 66.4429C1.20061 66.4509 0.825838 66.6908 0.688641 66.9694L-0.0822961 68.5049C-0.635875 69.6004 -1.42712 69.5565 -1.83928 68.3967L-2.36224 66.9263C-2.45826 66.6502 -2.77374 66.3752 -3.0588 66.3081L-4.75772 65.9353C-5.75658 65.7162 -5.95195 64.9753 -5.19678 64.2864L-4.00938 63.2182C-3.80887 63.0385 -3.67001 62.6707 -3.70106 62.4044L-3.90672 60.4667C-4.02612 59.4204 -3.38065 59.0072 -2.47005 59.5471Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55948 80.547L4.48583 82.1731C4.3358 82.3953 4.29536 82.7826 4.38542 83.0375L4.94863 84.5321C5.30782 85.488 4.79366 86.0561 3.80052 85.7945L2.12044 85.3443C1.84184 85.2696 1.43523 85.3688 1.21766 85.5729L0.0771009 86.6382C-0.822203 87.4785 -1.55036 87.1568 -1.53284 85.9263L-1.51136 84.2083C-1.50508 83.8978 -1.72757 83.5124 -1.99961 83.3626L-3.49821 82.5222C-4.56723 81.919 -4.48718 81.1306 -3.30976 80.772L-1.81692 80.3169C-1.53672 80.2336 -1.24753 79.931 -1.16753 79.6494L-0.717346 77.9693C-0.452671 76.9815 0.29634 76.8202 0.949909 77.6062L1.96271 78.8412C2.13305 79.0497 2.49404 79.2053 2.7615 79.1865L4.70659 79.0697C5.75727 78.9983 6.14045 79.6621 5.55948 80.547Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38537 76.5266L1.53125 73.3152",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9528 23.0709L72.8242 24.8138C72.9417 25.0548 73.2569 25.2835 73.5226 25.3329L75.0986 25.5925C76.106 25.7594 76.3409 26.4887 75.6178 27.2179L74.3879 28.4478C74.1839 28.6518 74.0665 29.0535 74.1345 29.344L74.4868 30.8644C74.7649 32.0634 74.1221 32.5331 73.0653 31.9027L71.5881 31.0251C71.3224 30.8644 70.8774 30.8644 70.6117 31.0251L69.1345 31.9027C68.0777 32.5269 67.4349 32.0634 67.713 30.8644L68.0653 29.344C68.1333 29.0597 68.0159 28.658 67.8119 28.4478L66.582 27.2179C65.8589 26.4948 66.0938 25.7655 67.1012 25.5925L68.6772 25.3329C68.9429 25.2897 69.2581 25.0548 69.3756 24.8138L70.247 23.0709C70.7105 22.1253 71.4769 22.1253 71.9528 23.0709Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.385 22.941H63.6768",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5309 31.5939H63.6768",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2948 27.2675H63.6768",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9784 16.4354L85.9048 18.0615C85.7547 18.2837 85.7143 18.671 85.8044 18.9259L86.3676 20.4206C86.7268 21.3764 86.2126 21.9445 85.2195 21.6829L83.5394 21.2327C83.2608 21.1581 82.8542 21.2572 82.6366 21.4614L81.496 22.5266C80.5967 23.367 79.8686 23.0452 79.8861 21.8147L79.9076 20.0967C79.9139 19.7862 79.6914 19.4008 79.4193 19.251L77.9207 18.4106C76.8517 17.8075 76.9318 17.0191 78.1092 16.6604L79.602 16.2053C79.8822 16.122 80.1714 15.8195 80.2514 15.5378L80.7016 13.8577C80.9663 12.8699 81.7153 12.7087 82.3689 13.4946L83.3817 14.7296C83.552 14.9382 83.913 15.0937 84.1804 15.0749L86.1255 14.9581C87.1762 14.8868 87.5594 15.5505 86.9784 16.4354Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8043 12.415L82.9502 9.20361",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3851 15.1357L75.458 13.53",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5141 11.9021L79.2051 11.3668",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1984 9.29141L60.8625 7.45947C60.9564 7.20835 60.9053 6.82231 60.7581 6.59553L59.8613 5.27382C59.2888 4.42831 59.656 3.75588 60.6828 3.7782L62.4215 3.82342C62.7099 3.83091 63.082 3.63948 63.2459 3.39019L64.106 2.08794C64.7841 1.06074 65.5673 1.20351 65.8377 2.40401L66.2182 4.07951C66.2846 4.38289 66.591 4.70561 66.8905 4.78771L68.544 5.25477C69.7243 5.59147 69.8307 6.37676 68.7696 7.00055L67.4244 7.79182C67.1715 7.93826 66.961 8.3 66.949 8.5926L66.9038 10.3313C66.8772 11.3536 66.1866 11.6854 65.3675 11.0739L64.0942 10.1097C63.8798 9.94671 63.4925 9.87981 63.2368 9.96059L61.3728 10.5285C60.3679 10.8434 59.8403 10.2876 60.1984 9.29141Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2487 12.6931L65.8018 15.3824",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8006 8.08035L72.0771 9.42505",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5139 11.9555L68.9395 12.4037",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5846 14.8836L53.2582 15.8817C53.487 16.0214 53.8758 16.0441 54.1263 15.9425L55.5936 15.3114C56.532 14.9088 57.123 15.3965 56.9071 16.4005L56.5343 18.0995C56.4725 18.3812 56.5902 18.7828 56.8041 18.9908L57.9204 20.0814C58.8011 20.9413 58.5129 21.6834 57.283 21.7223L55.5658 21.7795C55.2553 21.7874 54.8805 22.0273 54.7433 22.3059L53.9724 23.8414C53.4188 24.9369 52.6276 24.893 52.2154 23.7333L51.6924 22.2628C51.5964 21.9867 51.281 21.7117 50.9959 21.6447L49.297 21.2719C48.2981 21.0527 48.1027 20.3119 48.8579 19.623L50.0453 18.5547C50.2458 18.375 50.3847 18.0073 50.3536 17.741L50.148 15.8033C50.0286 14.7569 50.674 14.3438 51.5846 14.8836Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6681 17.2369L44.5449 19.2361",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7706 25.5238L49.209 26.5234",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3994 22.5466L46.8789 22.8798",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.702 4.44712L109.573 6.18998C109.691 6.43102 110.006 6.65969 110.272 6.70914L111.848 6.96871C112.855 7.13558 113.09 7.86487 112.367 8.59416L111.137 9.82406C110.933 10.028 110.816 10.4297 110.884 10.7202L111.236 12.2406C111.514 13.4396 110.871 13.9093 109.814 13.2789L108.337 12.4013C108.071 12.2406 107.626 12.2406 107.361 12.4013L105.884 13.2789C104.827 13.9031 104.184 13.4396 104.462 12.2406L104.814 10.7202C104.882 10.4359 104.765 10.0342 104.561 9.82406L103.331 8.59416C102.608 7.87105 102.843 7.14176 103.85 6.96871L105.426 6.70914C105.692 6.66587 106.007 6.43102 106.125 6.18998L106.996 4.44712C107.46 3.50151 108.226 3.50151 108.702 4.44712Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.136 4.31702H100.428",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.282 12.9697H100.428",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.046 8.64343H100.428",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.729 -2.18776L122.656 -0.561651C122.506 -0.339438 122.465 0.0478728 122.555 0.302747L123.119 1.7974C123.478 2.75328 122.964 3.32131 121.97 3.05973L120.29 2.60954C120.012 2.53489 119.605 2.63407 119.388 2.83819L118.247 3.90345C117.348 4.74381 116.62 4.42202 116.637 3.19156L116.659 1.47352C116.665 1.16303 116.442 0.777663 116.17 0.627855L114.672 -0.212565C113.603 -0.815712 113.683 -1.60412 114.86 -1.96276L116.353 -2.41786C116.633 -2.50113 116.922 -2.80369 117.002 -3.08539L117.453 -4.76546C117.717 -5.75324 118.466 -5.9145 119.12 -5.12858L120.133 -3.89352C120.303 -3.685 120.664 -3.52945 120.931 -3.54827L122.877 -3.66502C123.927 -3.73639 124.31 -3.07269 123.729 -2.18776Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3395 -3.74003L90.0131 -2.74193C90.2419 -2.60223 90.6307 -2.57957 90.8812 -2.6812L92.3485 -3.31224C93.2869 -3.71481 93.8779 -3.22719 93.662 -2.22312L93.2892 -0.524193C93.2274 -0.242463 93.3451 0.15918 93.5589 0.367178L94.6753 1.45777C95.556 2.31767 95.2678 3.05979 94.0379 3.09861L92.3206 3.15581C92.0102 3.16374 91.6354 3.40364 91.4982 3.68225L90.7273 5.21776C90.1737 6.31326 89.3825 6.26939 88.9703 5.10962L88.4473 3.63918C88.3513 3.36308 88.0358 3.08805 87.7508 3.02102L86.0519 2.64822C85.053 2.42904 84.8576 1.6882 85.6128 0.999339L86.8002 -0.0689329C87.0007 -0.248645 87.1396 -0.616378 87.1085 -0.882692L86.9028 -2.8204C86.7835 -3.86671 87.4289 -4.27988 88.3395 -3.74003Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.423 -1.38688L81.2998 0.612305",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5255 6.90031L85.9639 7.8999",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1524 3.92278L83.6318 4.25598",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6364 9.55661L41.5078 11.2995C41.6253 11.5405 41.9405 11.7692 42.2062 11.8186L43.7822 12.0782C44.7896 12.2451 45.0245 12.9744 44.3014 13.7037L43.0715 14.9336C42.8675 15.1375 42.7501 15.5392 42.8181 15.8297L43.1704 17.3501C43.4485 18.5491 42.8057 19.0188 41.7489 18.3884L40.2717 17.5108C40.006 17.3501 39.561 17.3501 39.2952 17.5108L37.8181 18.3884C36.7613 19.0126 36.1185 18.5491 36.3966 17.3501L36.7489 15.8297C36.8169 15.5454 36.6995 15.1437 36.4955 14.9336L35.2656 13.7037C34.5425 12.9806 34.7774 12.2513 35.7848 12.0782L37.3608 11.8186C37.6265 11.7754 37.9417 11.5405 38.0592 11.2995L38.9306 9.55661C39.3941 8.61101 40.1605 8.61101 40.6364 9.55661Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0686 9.42688H32.3604",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2145 18.0795H32.3604",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9784 13.7532H32.3604",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.664 2.92101L54.5903 4.54711C54.4403 4.76933 54.3999 5.15664 54.4899 5.41151L55.0531 6.90617C55.4123 7.86204 54.8982 8.43008 53.905 8.16849L52.2249 7.71831C51.9463 7.64365 51.5397 7.74283 51.3221 7.94695L50.1816 9.01222C49.2823 9.85257 48.5541 9.53078 48.5717 8.30033L48.5931 6.58229C48.5994 6.27179 48.3769 5.88643 48.1049 5.73662L46.6063 4.8962C45.5373 4.29305 45.6173 3.50465 46.7947 3.14601L48.2876 2.69091C48.5678 2.60763 48.857 2.30507 48.937 2.02338L49.3871 0.343307C49.6518 -0.644476 50.4008 -0.805732 51.0544 -0.0198194L52.0672 1.21524C52.2375 1.42377 52.5985 1.57931 52.866 1.56049L54.8111 1.44374C55.8618 1.37237 56.2449 2.03607 55.664 2.92101Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0696 1.62122L44.1426 0.0155029",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.884 -4.22337L29.548 -6.05531C29.642 -6.30642 29.5908 -6.69246 29.4437 -6.91924L28.5469 -8.24095C27.9743 -9.08646 28.3415 -9.75889 29.3683 -9.73657L31.1071 -9.69135C31.3954 -9.68386 31.7676 -9.87529 31.9314 -10.1246L32.7916 -11.4268C33.4697 -12.454 34.2528 -12.3113 34.5233 -11.1108L34.9038 -9.43526C34.9702 -9.13188 35.2766 -8.80916 35.5761 -8.72706L37.2295 -8.26C38.4099 -7.9233 38.5162 -7.13801 37.4552 -6.51422L36.11 -5.72295C35.857 -5.57651 35.6465 -5.21477 35.6345 -4.92218L35.5893 -3.18342C35.5627 -2.16114 34.8721 -1.82936 34.053 -2.44083L32.7797 -3.4051C32.5654 -3.56806 32.178 -3.63496 31.9224 -3.55418L30.0584 -2.98624C29.0535 -2.67138 28.5258 -3.22719 28.884 -4.22337Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9352 -0.82147L34.4883 1.86792",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2682 1.36923L21.9418 2.36732C22.1706 2.50702 22.5594 2.52968 22.8099 2.42805L24.2772 1.79701C25.2156 1.39444 25.8066 1.88206 25.5907 2.88613L25.2179 4.58506C25.1561 4.86679 25.2738 5.26843 25.4877 5.47643L26.604 6.56703C27.4847 7.42692 27.1965 8.16904 25.9666 8.20787L24.2494 8.26506C23.9389 8.273 23.5641 8.51289 23.4269 8.79151L22.656 10.327C22.1024 11.4225 21.3112 11.3786 20.899 10.2189L20.376 8.74843C20.28 8.47234 19.9645 8.1973 19.6795 8.13028L17.9806 7.75748C16.9817 7.5383 16.7863 6.79745 17.5415 6.10859L18.7289 5.04032C18.9294 4.86061 19.0683 4.49288 19.0372 4.22656L18.8316 2.28886C18.7122 1.24254 19.3576 0.829376 20.2682 1.36923Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3537 3.72201L13.2305 5.72119",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4551 12.0092L17.8936 13.0088",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0811 9.03191L15.5605 9.36511",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0116 15.6114L8.93797 17.2375C8.78794 17.4598 8.74751 17.8471 8.83757 18.1019L9.40078 19.5966C9.75997 20.5525 9.24581 21.1205 8.25267 20.8589L6.57259 20.4087C6.29398 20.3341 5.88738 20.4333 5.66981 20.6374L4.52925 21.7026C3.62995 22.543 2.90179 22.2212 2.91931 20.9908L2.94079 19.2727C2.94707 18.9622 2.72458 18.5769 2.45254 18.427L0.953938 17.5866C-0.115077 16.9835 -0.0350292 16.1951 1.14239 15.8364L2.63523 15.3813C2.91543 15.2981 3.20462 14.9955 3.28462 14.7138L3.7348 13.0337C3.99948 12.046 4.74849 11.8847 5.40206 12.6706L6.41485 13.9057C6.5852 14.1142 6.94619 14.2697 7.21365 14.2509L9.15873 14.1342C10.2094 14.0628 10.5926 14.7265 10.0116 15.6114Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83752 11.5911L5.9834 8.37964",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5473 11.0781L2.23828 10.5428",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_732_28958",
    x1: 282,
    y1: -0.0000303846,
    x2: 0.0000034279,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_732_28958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57 51) rotate(90) scale(148)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#D9D9D9",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#D9D9D9",
    stopOpacity: 0.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerClubBg);
export default __webpack_public_path__ + "static/media/customer-club-bg.10e34d6c6609c97bf0afb79af1505601.svg";
export { ForwardRef as ReactComponent };